// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Checkbox from "@mui/material/Checkbox";

// Soft UI Dashboard PRO React components
import SoftBox from "src/components/SoftBox";
import SoftTypography from "src/components/SoftTypography";
import { Link } from "@mui/material";
import { isDev } from "src/features/utils";
import logoQuickbooks from "src/assets/images/small-logos/logo-quickbooks.svg";

function IdCell({ id, checked, qboPaymentId, onChange }) {
  return (
    <SoftBox display="flex" alignItems="center">
      <Checkbox
        checked={checked}
        onClick={(e) => {
          e.stopPropagation();
          onChange && onChange(e);
        }}
      />
      <SoftBox ml={1} display="flex" flexDirection="row" alignItems="center">
        {qboPaymentId && (
          <SoftBox
            mt={1}
            display="flex"
            flexDirection="row"
            alignItems="center"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Link
              href={`https://app.${
                isDev() ? "sandbox." : ""
              }qbo.intuit.com/app/recvpayment?txnId=${qboPaymentId}`}
              target="_blank"
              lineHeight={1}
            >
              <SoftBox component="img" src={logoQuickbooks} width={35} />
            </Link>
          </SoftBox>
        )}
        <SoftTypography variant="caption" fontWeight="medium" color="text">
          # {id}
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

// Setting default value for the props of IdCell
IdCell.defaultProps = {
  checked: false,
};

// Typechecking props for the IdCell
IdCell.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  qboPaymentId: PropTypes.string,
  onChange: PropTypes.func,
};

export default IdCell;
